"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var QuoteSectionStore_1 = require("QuoteV2/Stores/QuoteSectionStore");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var inversify_react_1 = require("inversify-react");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var lodash_1 = require("lodash");
var BillingScheduleOrchestrator_1 = require("QuoteV2/BillingSchedule/BillingScheduleOrchestrator");
var PlanGroupTabs_1 = require("QuoteV2/Components/PlanGroupTabs");
var BillingScheduleHelpers_1 = require("./BillingScheduleHelpers");
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var ItemTypes_1 = require("QuoteV2/Models/ItemTypes");
var c = (0, BemBuilder_1.default)("quote-section-toolbar-options");
var PlanSectionAddGroupMenu = (function (_super) {
    __extends(PlanSectionAddGroupMenu, _super);
    function PlanSectionAddGroupMenu() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.orchestrator = new BillingScheduleOrchestrator_1.BillingScheduleOrchestrator();
        _this.isExistingFrequency = function (frequency) {
            var section = _this.props.section;
            if (frequency) {
                return section.groups.some(function (group) { return (0, QuoteSectionStore_1.isBillingScheduleGroup)(group) && (0, Types_1.isRecurringSchedule)(group) && group.frequency === frequency; });
            }
            return section.groups.some(function (group) { return (0, QuoteSectionStore_1.isBillingScheduleGroup)(group) && group.type === Types_1.BillingScheduleType.OneOff; });
        };
        _this.addGroup = function (frequency) {
            var _a = _this.props, section = _a.section, onAddGroup = _a.onAddGroup;
            var cloneFrom = (0, lodash_1.last)(section.groups.filter(function (group) { return (0, QuoteSectionStore_1.isBillingScheduleGroup)(group); }));
            var schedule = (0, PlanGroupTabs_1.frequencyToSchedule)(frequency);
            if (cloneFrom) {
                var clonedItems = section.itemsByGroup(cloneFrom).map(function (item) {
                    var _a;
                    var clone = (0, lodash_1.omit)((0, lodash_1.cloneDeep)(item.angularModel), "$id");
                    if (section.itemSingleSelect && ((_a = clone.interactive) === null || _a === void 0 ? void 0 : _a.isOptional)) {
                        clone.interactive.isOptionalSelected = false;
                    }
                    if (clone.type === Types_1.QuoteItemType.FixedCost || clone.type === Types_1.QuoteItemType.Variable) {
                        if ((0, Types_1.isRecurringSchedule)(schedule)) {
                            _this.orchestrator.setRecurringFrequency(clone, schedule.frequency);
                        }
                        else {
                            _this.orchestrator.setOneOffBillingSchedule(clone);
                        }
                    }
                    if (clone.type === Types_1.QuoteItemType.FixedCost) {
                        var fromFrequency = (0, PlanGroupTabs_1.scheduleToFrequency)(cloneFrom);
                        var convertedRate = (0, BillingScheduleHelpers_1.convertRateByBillingSchedule)(clone.rate.rate, fromFrequency, frequency);
                        clone.rate.rate = parseFloat(convertedRate.toFixed(_this.quoteCurrencyFormatter.idealDecimalPlaces()));
                    }
                    return clone;
                });
                section.addLineItems(clonedItems);
            }
            else {
                var newItem = new ItemTypes_1.ItemFactory().templateQuoteItem(Types_1.QuoteItemType.FixedCost, {
                    billingSchedule: (0, PlanGroupTabs_1.frequencyToSchedule)(frequency),
                    interactive: {
                        isOptional: true,
                        isQuantityOptional: true,
                    },
                });
                section.addLineItems(newItem);
            }
            _this.quoteTelemetry.trackPlanSectionAddFrequencyGroup(frequency);
            onAddGroup(schedule);
        };
        return _this;
    }
    PlanSectionAddGroupMenu.prototype.render = function () {
        var _this = this;
        var section = this.props.section;
        return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { autoStack: true, button: react_1.default.createElement(kaleidoscope_1.IconButton, { isRound: true, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, tooltip: { content: "Add frequency group" }, disabledReason: "Maximum groups reached", disabled: section.groups.length > Object.values(Types_1.RecurringFrequency).length, icon: react_1.default.createElement(icons_1.Add, null) }) },
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { disabled: this.isExistingFrequency(), onClick: function () { return _this.addGroup("one off"); } }, "Once"),
            Object.values(Types_1.RecurringFrequency).map(function (freq) { return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { key: freq, disabled: _this.isExistingFrequency(freq), onClick: function () { return _this.addGroup(freq); } }, freq)); })));
    };
    var _a, _b;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _a : Object)
    ], PlanSectionAddGroupMenu.prototype, "quoteTelemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_b = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _b : Object)
    ], PlanSectionAddGroupMenu.prototype, "quoteCurrencyFormatter", void 0);
    PlanSectionAddGroupMenu = __decorate([
        mobx_react_1.observer
    ], PlanSectionAddGroupMenu);
    return PlanSectionAddGroupMenu;
}(react_1.default.Component));
exports.default = PlanSectionAddGroupMenu;
